import EventEmitter from "./EventEmitter";
export default class ResumeOverlay extends EventEmitter {
  constructor(containerID, buttonID) {
    super();
    this.overlay = document.getElementById(containerID);
    this.button = document.getElementById(buttonID);
    this.button.addEventListener("click", this.onContinue.bind(this));
  }

  onContinue(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.emit("click");
  }

  show() {
    this.overlay.classList.remove("hidden");
  }

  hide() {
    this.overlay.classList.add("hidden");
  }
}
